import { selectorFamily, selector } from 'recoil';
import { apiClientState } from './api';
import { tokensState } from './auth';
import { TokensDto, UserDto } from '@oh-auth/dto';

export const usersQuery = selector({
	key: 'users',
	get: async ({ get }) => {
		const apiClient = get(apiClientState);
		const tokens = get(tokensState) as TokensDto;
		const user = await apiClient.readUsers(tokens);
		return user;
	},
});

export const userQuery = selectorFamily<UserDto, string>({
	key: 'user',
	get: (user_id) => async ({ get }) => {
		const apiClient = get(apiClientState);
		const tokens = get(tokensState) as TokensDto;
		const user = await apiClient.readUser(tokens, { user_id });
		return user;
	},
});

// export function useUpdateUser(user_id: string | null) {
// 	const [updating, setUpdating] = useState(false);

// 	const apiClient = useRecoilValue(apiClientState);
// 	const tokens = useRecoilValue(tokensState) as TokensDto;

// 	const handleUpdateUser = useCallback(
// 		(updateUserDto: UpdateUserBody) => {
// 			if (!user_id) return;
// 			setUpdating(true);
// 			return apiClient
// 				.updateUser(tokens, { user_id, ...updateUserDto })
// 				.then(() => {
// 					setUpdating(false);
// 				});
// 		},
// 		[apiClient, tokens, user_id]
// 	);

// 	return {
// 		updating,
// 		handleUpdateUser,
// 	};
// }

// export function useDeleteUser(user_id: string | null) {
// 	const [deleting, setDeleting] = useState(false);

// 	const apiClient = useRecoilValue(apiClientState);
// 	const tokens = useRecoilValue(tokensState) as TokensDto;

// 	const handleDeleteUser = useCallback(() => {
// 		if (!user_id) return;
// 		setDeleting(true);
// 		return apiClient.deleteUser(tokens, { user_id }).then(() => {
// 			setDeleting(false);
// 		});
// 	}, [apiClient, tokens, user_id]);

// 	return {
// 		deleting,
// 		handleDeleteUser,
// 	};
// }

// export function useCreateUser() {
// 	const [creating, setCreating] = useState(false);

// 	const apiClient = useRecoilValue(apiClientState);
// 	const tokens = useRecoilValue(tokensState) as TokensDto;

// 	const handleCreateUser = useCallback(
// 		(createUserDto: CreateUserBody) => {
// 			setCreating(true);
// 			apiClient.createUser(tokens, createUserDto).then(() => {
// 				setCreating(false);
// 			});
// 		},
// 		[apiClient, tokens]
// 	);

// 	return {
// 		creating,
// 		handleCreateUser,
// 	};
// }
